import React from 'react';
import { connect } from 'react-redux';

import { NormalizedStore } from '@store/entity/entity.types';
import { changeJourneyParam } from '@store/yourJourney/actions';
import { yourJourneySelectors } from '@store/yourJourney/selectors';

import { RoomsV2 } from './RoomsV2';
import { RoomsV2DispatchProps, RoomsV2OwnProps, RoomsV2StoreProps } from './RoomsV2.types';

const mapStateToProps = (state: NormalizedStore): RoomsV2StoreProps => ({
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

const mapDispatchToProps = (dispatch): RoomsV2DispatchProps => ({
  changeJourneyParam: (param, value) => changeJourneyParam(param, value)(dispatch),
});

export const RoomsV2Connected: React.ComponentType<RoomsV2OwnProps> = connect(
  mapStateToProps,
  mapDispatchToProps
)(RoomsV2);
